import * as React from "react";
import { ConfigProperties } from "../interfaces/customTypes/configProperties";
import defaultConfigProperties from "../defaultConfigProperties";

export const ConfigContext = React.createContext<ConfigProperties>(defaultConfigProperties);
export const ConfigContextProvider = ConfigContext.Provider;
